import React, { Fragment, Component } from "react";
import { I18n } from "react-redux-i18n";
import Icon from "@alboompro/boom-components/general/icon";

import { TabsContainer, TabItem, TabContent } from "./styles";

const TabDefinitions = [
  {
    id: "content",
    icon: {
      kind: "bold",
      group: "interface-essential",
      category: "edit",
      file: "pencil-1.svg",
      size: "18"
    }
  },
  {
    id: "styles",
    icon: {
      kind: "bold",
      group: "design",
      category: "colors-painting",
      file: "color-brush-paint.svg",
      size: "18"
    }
  },
  {
    id: "advanced",
    icon: {
      kind: "bold",
      group: "interface-essential",
      category: "settings",
      file: "cog-double-2.svg",
      size: "18"
    }
  }
];

class EditorTabs extends Component {
  constructor(props) {
    super(props);
    this.groupedManifest = this.groupManifestTypes(props.manifest);
    this.state = {
      active: Object.keys(this.groupedManifest)[0]
    };
  }

  /**
   * This will group manifest properties by it's type
   * returning them into an object.
   *
   * @return {Object} Grouped manifest properties.
   */
  groupManifestTypes = manifest => {
    const types = ["content", "styles", "advanced"];
    const ret = {};
    types.forEach(type => {
      const properties = manifest.props.filter(prop => prop.type === type);
      if (properties.length) {
        ret[type] = properties;
      }
    });
    return ret;
  };

  changeTab = nextTab => {
    this.setState({ active: nextTab });
  };

  render() {
    const { active } = this.state;
    const { render } = this.props;
    const activeTab = this.groupedManifest[active];

    return (
      <Fragment>
        <TabsContainer>
          {Object.keys(this.groupedManifest).map(group => {
            const item = TabDefinitions.find(i => i.id === group);
            return (
              <TabItem
                key={item.id}
                active={item.id === active}
                onClick={() => {
                  this.changeTab(item.id);
                }}
              >
                <Icon
                  {...item.icon}
                  color={item.id === active ? "#50AFF4" : "#626262"}
                />
                <span>{I18n.t(`editPanel.tabs.${item.id}`)}</span>
              </TabItem>
            );
          })}
        </TabsContainer>
        <TabContent>{render(activeTab)}</TabContent>
      </Fragment>
    );
  }
}

export default EditorTabs;
